<template>
  <div class="add-members-explanation-popup">
    <section class="add-team-popup-content">
      <div class="instructions">
        <h3 class="title">
          {{ $t('ADD_STAFF_MEMBERS_UPLOAD_CSV_INSTRUCTIONS_HEADER') }}:
        </h3>
        <ul class="instructions-list">
          <li class="instructions-item">
            <div class="inner">
              <strong>
                A)
                {{ $t('FIRST_NAME') }}
              </strong>
              <span class="required">*</span>
            </div>
          </li>
          <li class="instructions-item">
            <div class="inner">
              <strong>
                B)
                {{ $t('LAST_NAME') }}
              </strong>
              <span class="required">*</span>
            </div>
          </li>
          <li class="instructions-item">
            <div class="inner">
              <strong>
                C)
                {{ $t('EMAIL') }}
              </strong>
              <span class="required">*</span>
              <b>:&nbsp;</b>
              <span>
               {{ $t('ADD_STAFF_MEMBERS_UPLOAD_CSV_INSTRUCTIONS_EMAIL') }}
            </span>
            </div>
          </li>
          <li class="instructions-item">
            <div class="inner">
              <strong>
                D)
                {{ $t('ROLE') }}
              </strong>
              <span class="required">*</span>
              <b>:&nbsp;</b>
              <span>
              {{ $t('ADD_STAFF_MEMBERS_UPLOAD_CSV_INSTRUCTIONS_ROLE') }}:
            </span>
            </div>
            <ul class="instructions-permissions-list">
              <li class="instructions-permissions-item" v-for="permission in getPermissionTypes" :key="permission">
                <img src="@/assets/images/team-panel/person.svg" alt="person-icon" class="person-icon">
                <strong>{{ permission }}:</strong>
                <span>{{ getPermissionsExplanation(permission)}}</span>
              </li>
            </ul>
          </li>
          <li class="instructions-item">
            <div class="inner">
              <strong>
                E)
                {{ $t('ORGANIZATION') }}:
              </strong>
              {{ $t('ADD_STAFF_MEMBERS_UPLOAD_CSV_INSTRUCTIONS_ORGANIZATION') }}
            </div>
          </li>
        </ul>
      </div>
      <div class="upload" :class="{active: dragIsActive, error: isErrorFile }"
           @drop.prevent="dropFile"
           @dragover.prevent="dragIsActive = true"
           @dragleave="dragIsActive = false"
           @dragenter.prevent>
        <input type="file" id="uploadFile" style="display: none"
                 accept=".csv" @change="addFile">
        <div class="content" v-if="!selectedFile">
          <img src="@/assets/images/cloud.svg" alt="">
          <p class="text">{{ $t('DRAG_AND_DROP_CSV') }}</p>
          <label class="url" for="uploadFile">
            {{ $t('SELECT_FILE') }}
          </label>
        </div>
        <div class="content" v-else>
          <div class="file-type">
            <button class="delete-file" @click="removeFile">
              <img src="@/assets/images/team-panel/delete_file.svg">
            </button>
            <img src="@/assets/images/team-panel/csv_file_icon.svg">
          </div>
          <p>{{ selectedFile.name }}</p>
        </div>
        <div class="error-container">
           <div class="error-container-inner">
             <div class="file-type">
               <button class="delete-file" @click="removeFile">
                 <img src="@/assets/images/team-panel/delete_file.svg">
               </button>
               <label class="reload-file" for="uploadFile">
                 <img src="@/assets/images/team-panel/reload_again_icon.svg" alt="reload icon" class="reload-icon">
               </label>
             </div>
              <p v-if="selectedFile">{{ selectedFile.name }}</p>
           </div>
            <p class="error-text">
              <img src="@/assets/images/team-panel/warning_red_icon.svg" alt="warning icon" class="warning-icon">
              <span v-if="csvMsg">{{$t('ONLY_CSV_MSG')}}</span>
              <span v-else>{{$t('CSV_UPLOAD_FAILED')}}</span>
          </p>
        </div>
      </div>
    </section>
    <div class="upload-example">
      <p class="text">
        {{ $t('UPLOAD_CSV') }}
        <a href="https://fra1.digitaloceanspaces.com/classe-library-dev/uploads%2F1653461007579_users.csv" class="url">
          {{ $t('HERE') }}
        </a>
      </p>
      <img :src="getTableImg" class="image-example" alt="">
      <div class="buttons-wrap">
        <button class="common-button add-team"
            :class="{disable: !selectedFile || isErrorFile}"
            @click="addTeam">
          {{ $t('ADD_TEAM') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getPermissionTypes } from '@/utilityFunctions'

export default {
  name: 'add-members',

  data () {
    return {
      dragIsActive: false,
      selectedFile: null,
      isErrorFile: false,
      csvMsg: false
    }
  },

  computed: {
    ...mapState({
      lang: state => state.base.lang?.localName
    }),
    getTableImg () {
      if (this.lang) {
        return require('@/assets/images/team-panel/tables/table_' + this.lang + '.jpg')
      } else {
        // return default img
        return require('@/assets/images/team-panel/tables/table_he.jpg')
      }
    },
    getPermissionTypes
  },

  methods: {
    getPermissionsExplanation (permission) {
      const perKey = permission.toUpperCase()
      return this.$t(perKey + '_PERMISSION')
    },
    dropFile (event) {
      this.dragIsActive = false
      const file = event.dataTransfer.files[0]
      if (file.type !== 'text/csv') {
        this.isErrorFile = true
        this.csvMsg = true
      } else {
        this.isErrorFile = false
        this.csvMsg = false
      }
      this.selectedFile = file
    },
    removeFile () {
      this.selectedFile = null
      this.isErrorFile = false
      this.csvMsg = false
    },
    addFile (event) {
      this.selectedFile = event.target.files[0]
      this.isErrorFile = false
      this.csvMsg = false
    },
    addTeam () {
      this.$store.dispatch('addTeam', this.selectedFile).then(() => {
        this.$router.push({ name: 'staffList' })
      }).catch(() => {
        this.isErrorFile = true
        this.$store.dispatch('setLoader', false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-members-explanation-popup{
  max-height: 100vh; overflow: auto;
}
.add-team-popup {
  &-content {
    display: flex; justify-content: space-between;
    gap: 30px;
    width: 100%;
    margin: 40px auto 0;

    strong {
      white-space: nowrap;
      margin-inline-end: 3px;
    }

    .instructions {
      .title {
        font-size: 17px;
        font-weight: bold;
        color: #000;
        margin-bottom: 25px;
      }

      &-item {
        .inner {
          display: flex;
        }

        &:not(:last-child) {
          margin-bottom: 10px;
        }

        * {
          font-size: 0.8rem;
          line-height: 1.1;
        }
      }

      .instructions-permissions-list {
        margin-inline-start: 30px;
        margin-top: 10px;
      }

      .instructions-permissions-item {
        .person-icon {
          margin-inline-end: 5px;
        }

        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }

    .upload {
      display: grid; place-content: center; padding: 40px; width: 420px; border: 2px dashed #C8CDD0;
      background-color: #F8FAFB;
      .error-container{display: none; width: 100%;}
      &.error{
        border-color: #E32127; background-color: #FFEAE5;
        .content{display: none;}
        .error-container{
          display: block;
          .error-text{
            margin-top: 30px; text-align: center; font-size: 20px; font-weight: 600;
          }
          &-inner{width: max-content; margin-inline: auto;}
        }
        .reload-file{
          background-image: url("../assets/images/team-panel/paper_icon.svg"); background-repeat: no-repeat;
          width: 56px; height: 71px;
          display: flex; justify-content: center; align-items: center;
          .reload-icon{width: 29px; height: 29px;}
          &:hover{
            .reload-icon{
              .rtl &{animation: rotate-arrow 0.9s linear 1;}
              .ltr &{animation: ltr-rotate-arrow 0.9s linear 1;}
            }
          }
        }
      }

      .content {
        text-align: center;
        .text {
          color: #7C7C7C; font-size: 17px; font-weight: bold; margin: 15px 0 5px;
        }

        .url {
          color: #2D96E7; font-size: 17px; text-decoration: underline; cursor: pointer;
        }
      }
    }

    .active {
      border: 2px dashed #2D96E7;
    }
  }

  .upload-example {
    font-size: 17px; margin: 50px auto 0; width: fit-content;
    .text {margin-bottom: 10px;}

    .url {
      color: #33A0EA; text-decoration: underline; font-size: inherit
    }
  }
}
.file-type{
  display: flex; align-items: start; justify-content: center; position: relative; margin-bottom: 5px;
}
.delete-file{cursor: pointer; position: absolute; inset-inline-start: -25px; top: -10px;}
.image-example{width: 100%;}
@media screen and (max-width: 1599px){
  .add-team-popup-content,
  .image-example{max-width: 1078px;}
}
@media screen and (min-width: 1600px){
  .add-team-popup-content,
  .image-example{max-width: 1478px;}
}

</style>
